import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './AdvertiseWithUsPage.css';

const AdvertiseWithUsPage = () => {
  const [activeMenuItem, setActiveMenuItem] = useState('Home Page');

  const menuItems = [
    'Buyer Directory page Sponsor',
    'Home Page',
    'Category Page',
    'Buy Leads page',
    'Buyer Directory page'
  ];

  // Different ad banner configurations for each page type
  const adBannerConfigs = {
    'Buyer Directory page Sponsor': [
      { id: 1, title: 'Sponsored', size: '285x295 px', price: '$989/ Monthly', topPosition: 469 }
    ],
    'Home Page': [
      { id: 1, title: 'Main Banner', size: '770x434 px', price: '$989/ Monthly', topPosition: 206 },
      { id: 2, title: 'Ads Banner', size: '1360x306 px', price: '$989/ Monthly', topPosition: 802 },
      { id: 3, title: 'Ads Banner', size: '672x2x306 px', price: '$989/ Monthly', topPosition: 1213 },
      { id: 4, title: 'Ads Banner', size: '1360x2x408 px', price: '$989/ 2 weeks', topPosition: 1893 }
    ],
    'Category Page': [
      { id: 1, title: 'Ads Banner', size: '285x295 px', price: '$989/ Monthly', topPosition: 300 },
      { id: 2, title: 'Ads Banner', size: '285x535 px', price: '$989/ Monthly', topPosition: 650 }
    ],
    'Buy Leads page': [
      { id: 1, title: 'Ads Banner', size: '285x295 px', price: '$989/ Monthly', topPosition: 350 },
      { id: 2, title: 'Ads Banner', size: '285x535 px', price: '$989/ Monthly', topPosition: 700 }
    ],
    'Buyer Directory page': [
      { id: 1, title: 'Ads Banner', size: '285x295 px', price: '$989/ Monthly', topPosition: 451 },
      { id: 2, title: 'Ads Banner', size: '285x535 px', price: '$989/ Monthly', topPosition: 702 }
    ]
  };

  // Different preview images for each page type
  const previewImages = {
    'Buyer Directory page Sponsor': 'https://api.builder.io/api/v1/image/assets/TEMP/78fc8475f2e215b809cfe54bb1006195a9078379?width=1590',
    'Home Page': 'https://api.builder.io/api/v1/image/assets/TEMP/6ca2a5676e585cecf225d7a73e9b25d31647ac44?width=1592',
    'Category Page': 'https://api.builder.io/api/v1/image/assets/TEMP/78fc8475f2e215b809cfe54bb1006195a9078379?width=1590',
    'Buy Leads page': 'https://api.builder.io/api/v1/image/assets/TEMP/78fc8475f2e215b809cfe54bb1006195a9078379?width=1590',
    'Buyer Directory page': 'https://api.builder.io/api/v1/image/assets/TEMP/78fc8475f2e215b809cfe54bb1006195a9078379?width=1590'
  };

  const adBanners = adBannerConfigs[activeMenuItem] || adBannerConfigs['Home Page'];
  const previewImage = previewImages[activeMenuItem] || previewImages['Home Page'];

  return (
    <div className="advertise-with-us-page">
      <Header />
      
      {/* Hero Banner Section */}
      <section className="advertise-hero-banner">
        <div className="hero-content">
          <h1 className="hero-title">Advertise With Us</h1>
        </div>
        <div className="hero-image-container">
          <img 
            src="https://api.builder.io/api/v1/image/assets/TEMP/6bec70786adaaa55abcf083b048b9ee5a464ba33?width=864" 
            alt="Advertise With Us" 
            className="hero-image"
          />
        </div>
      </section>

      {/* Main Content Section */}
      <main className="advertise-main-content">
        <div className="advertise-container">
          {/* Sidebar Menu */}
          <div className="advertise-sidebar">
            <div className="sidebar-inner">
              <div className="sidebar-header">
                <h2 className="sidebar-title">Advertise with us</h2>
              </div>
              <nav className="sidebar-menu">
                {menuItems.map((item, index) => (
                  <button
                    key={index}
                    className={`sidebar-menu-item ${activeMenuItem === item ? 'active' : ''}`}
                    onClick={() => setActiveMenuItem(item)}
                  >
                    {item}
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Preview Section */}
          <div className="advertise-preview-section">
            <div className="preview-wrapper">
              <div className="preview-image-container">
                <img 
                  src={previewImage}
                  alt={`${activeMenuItem} Preview`} 
                  className="preview-image"
                />
              </div>

              {/* Ad Banner Info Cards */}
              {adBanners.map((banner) => (
                <div 
                  key={banner.id} 
                  className="ad-banner-card"
                  style={{ top: `${banner.topPosition}px` }}
                >
                  <div className="ad-banner-pointer-wrapper">
                    <svg className="ad-banner-pointer-svg" width="364" height="47" viewBox="0 0 364 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M242 47L364 47L364 0L0 0L0 23.5L242 23.5L242 47Z" fill="#FF9501"/>
                    </svg>
                  </div>
                  <div className="ad-banner-info">
                    <h3 className="ad-banner-title">{banner.title}</h3>
                    <div className="ad-banner-details">
                      <div className="ad-banner-detail">
                        <span className="detail-label">Size:</span>
                        <span className="detail-value">{banner.size}</span>
                      </div>
                      <div className="ad-banner-detail">
                        <span className="detail-label">Price:</span>
                        <span className="detail-value">{banner.price}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AdvertiseWithUsPage;
